import { render, staticRenderFns } from "./ProjectSectionStoryProperties.vue?vue&type=template&id=66959ad8"
import script from "./ProjectSectionStoryProperties.vue?vue&type=script&lang=js"
export * from "./ProjectSectionStoryProperties.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports